import { performPnpAutoLogin } from '../../api/register/pnpAutoLogin.ts';
import { initializePnpDeposit } from '../../components/pnpCashier/pnpCashier.api.ts';
import { pnpRetryStore } from '../../components/pnpCashier/pnpRetryStore.ts';
import { clearPnpSessionStorage } from '../../components/trustlyIframe/trustlyUtils.ts';
import { gatekeeper } from '../../utils/gatekeeper.ts';
import { clearDataInLocalStorage, resetProgressInLocalStorage } from '../../utils/utils.ts';

type Ctx = {
  market: string;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  setMetadata: (p: Record<string, any>) => void;
  resetBoundary: () => void;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  clearFormData: (mktInfo: any) => void;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  marketInfo: any;
  error: Error;
};

export const errorActions = {
  open_support: (ctx: Ctx) => {
    resetProgressInLocalStorage(ctx.market);
    gatekeeper?.messageBus?.publish('support', { kind: 'open' });
    ctx.setMetadata({ isOpen: false });
    ctx.resetBoundary();
  },

  redirect_kyc: (ctx: Ctx) => {
    const { token, pid } = {
      token: '',
      pid:   '',
      //eslint-disable-next-line @typescript-eslint/no-explicit-any
      ...(typeof ctx.error?.cause === 'object' ? (ctx.error.cause as any) : {}),
    };
    clearDataInLocalStorage(ctx.market);
    sessionStorage.setItem('fabric:registration:suppressAutoOpen', 'true');
    ctx.setMetadata({ isOpen: false });
    gatekeeper?.navigation?.navigate('/accountverification/:token/:pid', {
      params: { token, pid },
    });
    ctx.resetBoundary();
  },

  close_dialog: (ctx: Ctx) => {
    resetProgressInLocalStorage(ctx.market);
    sessionStorage.setItem('fabric:registration:open', 'false');
    ctx.setMetadata({ isOpen: false });
    ctx.resetBoundary();
  },

  restart_flow: (ctx: Ctx) => {
    resetProgressInLocalStorage(ctx.market);
    sessionStorage.setItem('fabric:registration:open', 'true');
    ctx.setMetadata({ isOpen: true });
    ctx.resetBoundary();
  },

  clear_and_close: (ctx: Ctx) => {
    ctx.clearFormData(ctx.marketInfo);
    clearDataInLocalStorage(ctx.market);
    sessionStorage.setItem('fabric:registration:open', 'false');
    ctx.setMetadata({ isOpen: false });
    ctx.resetBoundary();
  },

  noop: (_ctx: Ctx) => {
  },

  redirect_login: (ctx: Ctx) => {
    resetProgressInLocalStorage(ctx.market);
    ctx.setMetadata({ isOpen: false });
    ctx.resetBoundary();
    gatekeeper?.navigation?.navigate('/log-in', {});
  },

  back_to_cashier: (ctx: Ctx) => {
    clearPnpSessionStorage();
    ctx.setMetadata({ isOpen: true, trustlyCheckoutUrl: undefined });
    ctx.resetBoundary();
  },

  retry_pnp_login: (ctx: Ctx) => {
    performPnpAutoLogin().then(
      () => {
        ctx.resetBoundary();
      },
      (err) => {
        console.error('[PnpAutoLogin] Retry failed', err);
      },
    );
  },

  retry_pnp_init: (ctx: Ctx) => {
    const payload = pnpRetryStore.get();
    if (!payload) {
      ctx.resetBoundary();

      return;
    }
    initializePnpDeposit(payload).then(
      (result) => {
        ctx.setMetadata({ isOpen: true, trustlyCheckoutUrl: result.url });
        ctx.resetBoundary();
      },
      (err) => {
        console.error('[PnpRetry] Retry failed', err);
      },
    );
  },
} as const;

export type ErrorActionId = keyof typeof errorActions;
